import './NotFound.css';
import { Link } from 'react-router-dom';
import { Typography } from 'antd';

import { WarningOutlined } from '@vindr/icons';
import { useTranslation } from 'react-i18next';
import Header from '#components/ui/Header/Header';

export default function NotFound({
  message = 'Sorry, this page does not exist.',
  showGoBackButton = true,
}: {
  message?: string;
  showGoBackButton?: boolean;
}) {
  const { t }: { t: (key: string) => string } = useTranslation('Vindoc');

  return (
    <>
      <Header />
      <div className="not-found text-center">
        <div>
          {/* <WarningIcon fontSize="large" /> */}
          <WarningOutlined style={{ fontSize: 35 }} />
          <Typography style={{ fontSize: 24 }}>{t(message)}</Typography>
          {showGoBackButton && (
            <Typography style={{ fontSize: 14 }}>
              <Link to={'/'}>{t('Go back Home')}</Link>
            </Typography>
          )}
        </div>
      </div>
    </>
  );
}
